<script lang="ts">
    export let label: string = 'BUTTON';
    export let bgColor: string = 'black';
    export let color: string = 'white';
    export let onClick: ((e: Event) => any)|undefined = undefined;

    let btnElement: HTMLButtonElement;

    function handleClick(e) {
        if (onClick) { onClick(e); }
    }
</script>


<button
    class="ivdemo-text-button"
    bind:this={btnElement}
    style={`background-color:${bgColor};color:${color}`}
    on:click={handleClick}
>
    {label}
</button>


<style>
    .ivdemo-text-button {
        font-size: 0.8rem;
        font-weight: bold;
        user-select: none;
        -webkit-user-select: none;
        border: 0;
        padding: 0;
        margin: 0;
        border-radius: 0;
    }
    .ivdemo-text-button:hover {
        filter: invert(1);
    }
</style>

